import ScanService from "../services.js/scan.service";
import { SCAN_WEBSITE, SUBMIT_REPORT, STORE_CONTACT } from "../reducers/constants";
import swal from 'sweetalert';

export const scanWebsite = (data, setSubmitting, resetForm, setIsChecked) => async (dispatch) => {
  try {
    const resultData = await ScanService.scanWebsite(data);
    setIsChecked(false)
    if (resultData) {
      if (resultData && resultData?.status === true) {

        dispatch({
          type: SCAN_WEBSITE,
          payload: resultData,
        });
        setSubmitting(false)
        resetForm();

      } else {
        dispatch({
          type: SCAN_WEBSITE,
          payload: resultData,
        });
        setSubmitting(false)
        resetForm();
      }
    }
    else {
      setSubmitting(false)
      resetForm();
      let errorData = { status: false, message: "Please try again !" }
      dispatch({
        type: SCAN_WEBSITE,
        payload: errorData,
      });
      // swal("Please try again !", "", "error");
    }
  }
  catch (error) {
    console.log(error)
  }
};

export const submitReport = (data, setSubmitting, resetForm) => async (dispatch) => {
  try {
    const resultData = await ScanService.submitReport(data);

    if (resultData) {
      if (resultData && resultData?.status === true) {

        dispatch({
          type: SUBMIT_REPORT,
          payload: resultData,
        });
        setSubmitting(false)
        resetForm();
      } else {
        dispatch({
          type: SUBMIT_REPORT,
          payload: resultData,
        });
        setSubmitting(false)
        resetForm();
      }
    }
    else {
      setSubmitting(false)
      resetForm();
      let errorData = { status: false, message: "Please try again !" }
      dispatch({
        type: SUBMIT_REPORT,
        payload: errorData,
      });
      // swal("Please try again !", "", "error");
    }
  }
  catch (error) {
    console.log(error)
  }
};

export const storeContact = (data, setSubmitting, resetForm, setLoading) => async (dispatch) => {
  try {
    const resultData = await ScanService.storeContact(data);

    if (resultData) {
      if (resultData && resultData?.status === true) {

        dispatch({
          type: STORE_CONTACT,
          payload: resultData,
        });

        if (setSubmitting) {
          setSubmitting(false)
        }
        if (resetForm) {
          resetForm()
        }
        if (setLoading) {
          setLoading(false)
        }
      } else {
        dispatch({
          type: STORE_CONTACT,
          payload: resultData,
        });

        if (setSubmitting) {
          setSubmitting(false)
        }
        if (resetForm) {
          resetForm()
        }
        if (setLoading) {
          setLoading(false)
        }
      }
    }
    else {
      if (setSubmitting) {
        setSubmitting(false)
      }
      if (resetForm) {
        resetForm()
      }
      if (setLoading) {
        setLoading(false)
      }

      let errorData = { status: false, message: "Please try again !" }
      dispatch({
        type: STORE_CONTACT,
        payload: errorData,
      });
      // swal("Please try again !", "", "error");
    }
  }
  catch (error) {
    console.log(error)
  }
};
